import { CertificateTabProps, DecennialCertificateColumns } from "@dune/types";
import { Button, DataTable } from "@dune/ui";
import { Plus } from "lucide-react";
import React, { useState } from "react";
import { useDocumentStore } from "../../../../../stores/document.store";
import { getCertificateForContractorColumns } from "../certificateForContractorColumns";
import UploadCertificateModal from "./UploadCertificateModal";

const CertificateTab: React.FC<CertificateTabProps> = ({
	certificates,
	contractorId,
}) => {
	const selectDocument = useDocumentStore((state) => state.selectDocument);
	const [isUploadModalOpen, setIsUploadModalOpen] = useState(false);

	const handleRowClick = (certificate: DecennialCertificateColumns) => {
		if (certificate.id && certificate.file) {
			selectDocument("", certificate.file.id, undefined, certificate.file.name);
		}
	};

	const columns = getCertificateForContractorColumns();

	return (
		<div>
			<div className="flex justify-between items-center py-4">
				<h2 className="text-text-main-blue font-semibold">ATTESTATIONS</h2>
				<Button onClick={() => setIsUploadModalOpen(true)}>
					<Plus className="w-4 h-4 mr-2" />
					Nouveau
				</Button>
			</div>
			<div>
				<DataTable
					variant="default"
					columns={columns}
					data={certificates}
					noResultsText="Aucune attestation disponible"
					onRowClick={handleRowClick}
				/>
			</div>
			<UploadCertificateModal
				open={isUploadModalOpen}
				onOpenChange={setIsUploadModalOpen}
				contractorId={contractorId}
			/>
		</div>
	);
};

export default CertificateTab;
